import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Button } from '@/common/components/Button/Button';
import { IllustrationImage } from '@/common/components/Illustrations/IllustrationImage';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { Stack } from '@/common/components/Stack/Stack';
import { Translate } from '@/common/components/Translate/Translate';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { useRouter } from 'expo-router';

export const ITMealBuoniPastoWelcomeLearningCenter = ({
  onClose,
}: TITMealBuoniPastoWelcomeLearningCenterProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[50rem]">
      <ModalLearning.Step
        title={t(
          'dashboard.it.meal.buoni_pasto.page.learning_center.step_1.title'
        )}
        description={
          <Translate
            parent={BodyText}
            i18nKey="dashboard.it.meal.buoni_pasto.page.learning_center.step_1.description"
          />
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-card-buoni-pasto.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_learning_center_1st_time_step1_page'
          );
        }}
      />
      <ModalLearning.Step
        title={t(
          'dashboard.it.meal.buoni_pasto.page.learning_center.step_2.title'
        )}
        description={
          <Translate
            parent={BodyText}
            i18nKey="dashboard.it.meal.buoni_pasto.page.learning_center.step_2.description"
          />
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-card-pos.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_learning_center_1st_time_step2_page'
          );
        }}
      />
      <ModalLearning.Step
        title={t(
          'dashboard.it.meal.buoni_pasto.page.learning_center.step_3.title'
        )}
        description={
          <Stack gap="md" align="start">
            <Translate
              parent={BodyText}
              i18nKey="dashboard.it.meal.buoni_pasto.page.learning_center.step_3.description"
            />

            <Button
              variant="primary"
              onPress={() => {
                AnalyticsService.trackCustomEvent(
                  'single_transaction_learning_center_1st_time_select_payment_method_button_clicked'
                );
                onClose();
                router.navigate(ROUTES.MEAL_VOUCHER_PAYMENT);
              }}
            >
              {t(
                'dashboard.it.meal.buoni_pasto.page.learning_center.step_3.button.label'
              )}
            </Button>
            <View />
          </Stack>
        }
        asset={
          <IllustrationImage
            source={require('@/assets/illustrations/illustration-card-form.png')}
            transition={250}
          />
        }
        onShow={() => {
          AnalyticsService.trackPageView(
            'single_transaction_learning_center_1st_time_step3_page'
          );
        }}
      />
    </ModalLearning.Root>
  );
};

export type TITMealBuoniPastoWelcomeLearningCenterProps = {
  onClose: () => void;
};
